var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.011,
    height: 19.415,
    viewBox: "0 0 21.011 19.415",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-469.704 -364.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.976 2.347)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#313131",
    stroke: "#313131",
    strokeWidth: "0.5px",
    d: "M56.959,16.826A4.92,4.92,0,0,1,52.281,13.3a4.922,4.922,0,0,1-4-3.041,5.172,5.172,0,0,1,.637-5.076,4.837,4.837,0,0,1,4.623-1.9,4.858,4.858,0,0,1,9.107,0,4.847,4.847,0,0,1,4.722,2.042,5.179,5.179,0,0,1,.384,5.261,4.894,4.894,0,0,1-4.385,2.746,4.716,4.716,0,0,1-1.668-.307,4.9,4.9,0,0,1-4.744,3.8ZM52.8,4a4.208,4.208,0,0,0-4.153,4.164,4.223,4.223,0,0,0,3.94,4.377.38.38,0,0,1,.346.293,4.128,4.128,0,0,0,8.123-.409.388.388,0,0,1,.2-.285.369.369,0,0,1,.34,0,4.013,4.013,0,0,0,1.785.419,4.144,4.144,0,0,0,3.746-2.41,4.378,4.378,0,0,0-.481-4.519,4.09,4.09,0,0,0-4.163-1.519.377.377,0,0,1-.44-.259,4.116,4.116,0,0,0-7.9,0,.377.377,0,0,1-.44.259,4.073,4.073,0,0,0-.9-.1Zm0,0",
    transform: "translate(423.086 362.537)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#313131",
    stroke: "#313131",
    strokeWidth: "0.5px",
    d: "M73.944,331.952a1.944,1.944,0,1,1,1.944-1.944A1.944,1.944,0,0,1,73.944,331.952Zm0-3.11a1.164,1.164,0,1,0,.825.341,1.167,1.167,0,0,0-.825-.341Zm0,0",
    transform: "translate(400.085 49.616)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.684d08a1e01ce5e952f242ed88399658.svg";
export { ForwardRef as ReactComponent };